module.exports = __webpack_public_path__ + "static/media/gupta.0f198f82.jpeg";